import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IVehicleType } from '../interfaces/vehicle-type';
import { IVehicleTypeFilter } from '../interfaces/vehicle-type-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class VehicleTypeService extends EditService<IVehicleType, IVehicleTypeFilter> {
  url = '/api/vehicletypes';
  entityTitle = 'VehicleType';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
